export const DMCA_LINK = 'https://tellus.social/about/support/copyright'
